import { render, staticRenderFns } from "./TenantHomeportal2BrandingPreview.vue?vue&type=template&id=2224253f&scoped=true&"
import script from "./TenantHomeportal2BrandingPreview.vue?vue&type=script&lang=js&"
export * from "./TenantHomeportal2BrandingPreview.vue?vue&type=script&lang=js&"
import style0 from "./TenantHomeportal2BrandingPreview.vue?vue&type=style&index=0&id=2224253f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224253f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
